<div class="d-flex flex-column justify-content-between" style="max-height: 100vh; min-height: 100vh;height:100%;max-width: 100vw; min-width: 100vw;width:100%">
  <div class="d-flex bg-white">
    <div class="h-100 w-75 d-flex justify-content-center align-items-center position-relative">
      <img src="assets/Berghaus_Landingpage_v53.jpg"
        style="object-fit:cover; width: 75vw; max-height:calc(100vh - 45px);">
      <img class="avs-login-logo" src="assets/logo/AVS_Verkehrssicherung_HZ_Transparent.png" class="position-absolute"
        style="bottom: 50px; left: 10px; height: 128px">
    </div>
    <div class="card rounded-0 w-25">
      <div class="card-body login-card-body">
        <span class="d-flex justify-content-center mt-4">
          <img class="avs-login-logo" src="assets/logo/avs.svg">
        </span>
        <div class="login-step-copy mt-5">
          <h4 class="mb-1">{{ getStepTitle() }}</h4>
          <p class="text-secondary mb-0">{{ getStepDescription() }}</p>
        </div>

        <form *ngIf="step === 'form'" novalidate (ngSubmit)="onSubmitClicked()" #form="ngForm">
          <div class="mt-4">
            <avs-password-confirm-input placeholderNew="Passwort eingeben..."
              placeholderConfirm="Passwort wiederholen..." (passwordChange)="onPasswordChange($event)">
            </avs-password-confirm-input>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <button class="btn btn-secondary rounded-0 mt-3" [disabled]="!canSubmit" type="submit">
              {{ isLoading ? 'Speichern...' : 'Passwort speichern' }}
            </button>
          </div>
        </form>

        <div *ngIf="step === 'invalid'" class="mt-4">
          <p class="text-secondary">
            Fordern Sie über „Passwort vergessen?“ auf der Anmeldeseite einen neuen Link an.
          </p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary rounded-0 mt-3" type="button" (click)="onGoToLoginClicked()">
              Zur Anmeldung
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <avs-app-footer></avs-app-footer>
  </div>
</div>
